/* ============
 * The initial state of the organisations module.
 * ============
 */
export default {
  organisation: {},
  organisationLoading: false
};
